import { SearchIcon } from "@chakra-ui/icons";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/input";
import { Box, Flex, Heading } from "@chakra-ui/layout";
import React, { SetStateAction } from "react";
import { useHistory } from "react-router-dom";
import AddQuoteMenu, { AddQuoteMenuActions } from "./AddQuoteMenu";

type QuotesTableToolbarProps = {
  setGlobalFilter: React.Dispatch<SetStateAction<string>>;
  newQuoteHandler: () => void;
  tableTitle: string;
};

function QuotesTableToolbar({
  setGlobalFilter,
  tableTitle,
}: QuotesTableToolbarProps) {
  const history = useHistory();

  const handleChange = (e: any) => {
    setGlobalFilter(e.target.value);
  };

  const addQuoteHandler = (action: AddQuoteMenuActions) => {
    history.push(`/quotes/new?type=${action.toLowerCase()}`);
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gridGap={4}
    >
      <Heading size="lg">{tableTitle}</Heading>

      <Flex flexWrap="wrap" maxW="550px" width="full" gridGap={4}>
        <InputGroup flex="1" size="md" minW="150px" marginRight={6}>
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon color="gray.300" />}
          />
          <Input
            onChange={handleChange}
            type="text"
            placeholder="Filter by keyword"
          />
        </InputGroup>
        <Box>
          <AddQuoteMenu menuItemClickHandler={addQuoteHandler} />
        </Box>
      </Flex>
    </Flex>
  );
}

export default QuotesTableToolbar;
